export default class GovtDepartment {
  id: string;
  name: string;
  namegujarati: string;
  icon: string | null;
  iconUrl: string | null;
  isactive: boolean;

  constructor(data: Partial<GovtDepartment> = {}) {
    this.id = data.id || "";
    this.name = data.name || "";
    this.namegujarati = data.namegujarati || "";
    this.icon = data.icon || null;
    this.iconUrl = data.iconUrl || null;
    this.isactive = data.isactive ?? true;
  }
}
